import PropTypes from 'prop-types';
import styled from 'styled-components';

const ScratchedStart = styled.span`
  text-decoration: ${props => (props.lined ? 'line-through' : 'none')};
`;

const Start = ({ start, showName = true, className }) => {
  const text = [start?.start_number, showName ? start?.horse_name : undefined]
    .filter(Boolean)
    .join(' ');
  return start?.scratched ? (
    <ScratchedStart className={className} lined={showName}>
      {text}
    </ScratchedStart>
  ) : (
    <span className={className}>{text}</span>
  );
};

Start.propTypes = {
  start: PropTypes.shape({
    start_number: PropTypes.number.isRequired,
    horse_name: PropTypes.string.isRequired,
    scratched: PropTypes.bool.isRequired,
  }).isRequired,
  showName: PropTypes.bool,
  className: PropTypes.string,
};

export default Start;
